import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    graphContainer: {
        height: 'calc(100% - 25px)'
    },
    graphFooter: {
        color: 'grey',
        marginTop: '10px',
        textAlign: 'center',
        width: '100%'
    },
    graphPageContainer: {
        height: 'calc(100% - 95px)',
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1),
        width: '100%'
    },
    header: {
        display: 'flex',
        height: '65px',
        justifyContent: 'space-between',
        marginBottom: '30px',
        width: '100%'
    },
    headerActions: {
        alignSelf: 'center',
        marginRight: '15px',
        width: '160px'
    },
    headerSelectors: {
        width: 'calc(100% - 150px)'
    },
    root: {
        height: '100%',
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1),
        width: '100%'
    }
}));

export default useStyles;
